import { Head } from '@inertiajs/react';
import { Banner, BannerHeader, BannerText } from '../Components/Banners';
import { Section, Rule } from '../Components';

export default function Terms({ recaptcha }: any) {
    return (
        <>
            <Head>
                <title>Terms & Conditions</title>
                <meta
                    name='description'
                    content='We are a UK based business specialising in optimising private hire travel through innovative technological solutions.'
                />
            </Head>

            <Banner className='py-38'>
                <BannerHeader>Terms & Conditions</BannerHeader>
                <Rule className='mx-auto w-1/2 max-w-60' />
                <BannerText>
                    View our Terms & Conditions and Website Privacy Policy
                </BannerText>
            </Banner>

            <Section id='cookies-policy' className='py-12 lg:py-20'>
                <div className='w-full max-w-full prose-h2:text-3xl prose-h2:lg:text-4xl prose'>
                    <h2>Cookies Policy</h2>

                    <Rule className='w-1/2 max-w-80' />

                    <h3>What are cookies?</h3>
                    <p>
                        'Cookies' are simple text files stored on your device
                        (computer, mobile, etc) whenever you visit a website.
                        These allow the website to operate.
                    </p>
                    <p>
                        Some cookies are stored for the duration of your visit
                        (or 'session') and are destroyed when you close your
                        browser. Others are retained for a pre-determined period
                        of time ('persistent') and allow the site to recall
                        certain information about your previous visits to the
                        site. These also permit the website operator to learn
                        about how visitors use their site and to make
                        improvements to it based on that information.
                    </p>
                    <p>
                        Like the vast majority of website operators, we make use
                        of <strong>Google Analytics</strong> and similar
                        services to monitor usage of our website and make
                        improvements, which entails the usage of cookies.
                    </p>
                    <p>
                        If you object to the usage of cookies for any reason,
                        you may configure your chosen web browser to reject or
                        disallow cookies from particular domains. Note that
                        doing so may interfere with the normal operation of
                        websites.
                    </p>

                    <h3>How we use them</h3>

                    <p>Details of our cookie usage are provided below.</p>
                    <ul>
                        <li>
                            <strong>Google Analytics Cookies</strong>: Two
                            anonymous cookies generated by Google Analytics for
                            the purpose distinguishing between visitor sessions
                        </li>
                        <li>
                            <strong>Consent Status Cookie</strong>: This cookie
                            in your browser localstorage tracks whether this
                            browser has confirmed it's acceptance of our
                            policy(s)
                        </li>
                    </ul>

                    <h2>Privacy Policy</h2>

                    <Rule className='w-1/2 max-w-80' />

                    <h3>1. Introduction</h3>
                    <ol>
                        <li>
                            The term Onward Travel Solutions or 'us' or 'we'
                            refers to the owner of the website whose registered
                            office is 3 Viking House, Cheddar Business Park,
                            Wedmore Road, Cheddar, Somerset, BS27 3EB.
                        </li>
                        <li>
                            We collect and store the minimum information
                            possible to provide the services you've requested
                            (i.e. to process your order). We may also use this
                            information for auditing, research and analysis to
                            operate and improve our technologies and services.
                        </li>
                        <li>
                            The term 'you' refers to the user or viewer of our
                            website.
                        </li>
                        <li>
                            Where required to fulfil your transfer, we may pass
                            selected information to third parties.
                        </li>
                        <li>
                            We may update this policy from time to time by
                            publishing a new version on our website.
                        </li>
                        <li>
                            You should check this page occasionally to ensure
                            you are happy with any changes to this policy.
                        </li>
                    </ol>

                    <h3>2. How we collect and use your personal data</h3>
                    <ol>
                        <li>
                            In this Section we set out:
                            <ol>
                                <li>
                                    the categories of personal data that we may
                                    process;
                                </li>
                                <li>
                                    the reason why we may process personal data;
                                </li>
                                <li>
                                    the legal basis for processing this data;
                                </li>
                                <li>
                                    when we provide your personal data to
                                    others;
                                </li>
                                <li>
                                    the steps we take to protect your personal
                                    data.{' '}
                                </li>
                            </ol>
                        </li>
                        <li>
                            We may collect and process data about your use of
                            our website ('analytics data'). The analytics data
                            may include any of the following: your IP address;
                            approximate location, internet browser type and
                            version, your PC's operating system, the source of
                            referral, length of your visit, and website
                            navigation paths, as well as information about the
                            frequency, and pattern of your visits. We gather
                            this data through the Google Analytics service. The
                            legal basis for the processing of this data is our
                            legitimate interests in improving our website and
                            service.
                        </li>
                        <li>
                            We collect and process data relating to your Form
                            Submissions. This data includes: your name, email
                            address, phone number). You will be required to
                            provide this data during submitting of forms. The
                            legal basis for processing this data is for us to
                            reply to your queries.
                        </li>
                        <li>
                            We may process information contained in or relating
                            to any communication that you send to or have with
                            us ('correspondence data'). The correspondence data
                            may include: email content, online chat transcripts,
                            call recordings and metadata associated with the
                            communication. The correspondence data may be
                            processed for the purposes of communicating with
                            you.{' '}
                        </li>
                        <li>
                            We may process your personal data where necessary,
                            for use in the defence of legal claims in court or
                            another legal proceeding. The legal basis for this
                            is to protect and assert our legal rights, the
                            rights of our customers or the rights of others.
                        </li>
                        <li>
                            We may process any of your personal data where such
                            processing is necessary to comply with a legal
                            obligation to which we are subject, or to protect
                            your interests or the interests of another person.
                        </li>
                    </ol>

                    <h3>3. Retaining and deleting personal data</h3>
                    <ol>
                        <li>
                            This Section sets out our data retention policies,
                            these are designed to ensure that we comply with our
                            legal obligations in relation to the retention and
                            deletion of personal data and are designed so that
                            we maintain the lowest possible level of risk to our
                            customers.
                        </li>
                        <li>
                            Personal data that we process for any purpose or
                            purposes shall not be kept for longer than is
                            necessary to fulfil the purchased service and our,
                            or a third-parties, legal obligations.
                        </li>
                        <li>
                            We will retain and delete your personal data as
                            follows:
                            <ol>
                                <li>
                                    <i>Analytics Data:</i>
                                    <ol>
                                        <li>
                                            <i>Google Analytics</i> retains data
                                            relating to a visit to our website{' '}
                                            <em>indefinitely</em>, the data
                                            collected is non-identifiable.
                                        </li>
                                    </ol>
                                </li>
                                <li>
                                    <i>Correspondence Data</i> will be retained
                                    for at most <em>18 months</em> following{' '}
                                    <i>its collection,</i> at the end of which
                                    period it will be deleted from our systems.
                                    Transactional correspondences issued by us
                                    are retained for 6 years from the end of
                                    last tax period in order to comply with the
                                    Finance Act of 1988, Schedule 18, Part 3,
                                    Section 21(2) which requires us to preserve
                                    relevant transactional information.
                                </li>
                            </ol>
                        </li>
                        <li>
                            We may retain your personal data where it is vital
                            for use in defence of legal claims in court or
                            another legal proceeding.
                        </li>
                        <li>
                            We may retain your personal data where such
                            retention is necessary for compliance with a legal
                            obligation to which we are subject, or in order to
                            protect your vital interests or the vital interests
                            of another natural person.
                        </li>
                    </ol>

                    <h3>4. Your rights</h3>
                    <ol>
                        <li>
                            You have the right to access; rectify or request the
                            removal of any personal information we hold about
                            you. We are legally bound to provide/remove this
                            information free of charge within 30 days. This
                            right however is subject to some limitations:
                            <ol>
                                <li>
                                    There may be a legal reason we cannot remove
                                    the data.
                                </li>
                                <li>
                                    The data may be integral to providing the
                                    service, deleting or removing it would
                                    result in the cancellation of service. In
                                    this case you would be subject to our normal
                                    cancellation fees / procedure.
                                </li>
                                <li>
                                    You will be required to supply proof of your
                                    identity, in most circumstances we will
                                    accept two forms of ID such as a passport,
                                    driving licence or a copy of a utility bill
                                    showing your address listed. This
                                    information must be provided by email or
                                    post along with your request to which you
                                    will receive confirmation of receipt by us
                                    within 5 days.
                                </li>
                            </ol>
                        </li>
                        <li>
                            If the request is complicated the timeframe for
                            rectification can be extended by up to two months.
                        </li>
                        <li>
                            You have the right to lodge a complaint with a
                            supervisory authority.
                        </li>
                        <li>
                            You have the right to withdraw consent to our use of
                            this data. In some cases this may result
                            cancellation of your service and any relevant
                            charges.
                        </li>
                    </ol>
                </div>
            </Section>
        </>
    );
}
